import { connect } from 'react-redux';
import { getIsLoggedIn, getCartCount, getCanUserSeeWatch, getCurrentUserHasCore, } from '../../publicSession/selectors';
import { deletePortfolio } from '../../SiteHeader/redux/actions';
import { getChatUnreadCount } from '../../Chat/redux/selectors';
var mapStateToProps = function (state) { return ({
    hasCoreMembership: getCurrentUserHasCore(state),
    chatCount: getChatUnreadCount(state),
    isLoggedIn: getIsLoggedIn(state),
    cartCount: getCartCount(state),
    canSeeOldWatch: getCanUserSeeWatch(state),
}); };
var mapDispatchToProps = {
    deletePortfolio: deletePortfolio,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SiteHeaderDesktop.container.js.map